import * as React from 'react'
import g from 'glamorous'
import { RouteComponentProps } from 'react-router'
import * as moment from 'moment'

import Navbar from '../components/Navbar'
import LoanQuery from '../components/queries/LoanQuery'
import MeQuery from '../components/queries/MeQuery'
import LoanPaymentMutation from '../components/mutations/LoanPaymentMutation'
import Loading from '../components/Loading'
import LoanPaymentForm from './loanPayment/LoanPaymentForm'
import { adopt } from 'react-adopt'
import { GetChildrenRenderProp } from '../types'
import history from '../history'
import { loanQueries } from '../utils/refetchQueries'
import { UserRole } from '../graphql/queries/me'
import Headline from '../components/Headline'

const StyledContainer = g.div(({ theme }) => {
  return {
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto'
  }
})

interface ComposedProps {
  loanId: string
}

interface RenderProps {
  loan: GetChildrenRenderProp<typeof LoanQuery>
  me: GetChildrenRenderProp<typeof MeQuery>
  payLoan: GetChildrenRenderProp<typeof LoanPaymentMutation>
}

const Composed = adopt<RenderProps, ComposedProps>({
  loan: ({ render, loanId }) => (
    <LoanQuery variables={{ id: loanId }}>
      {data => render && render(data)}
    </LoanQuery>
  ),
  me: ({ render }) => <MeQuery>{data => render && render(data)}</MeQuery>,
  payLoan: ({ render }) => (
    <LoanPaymentMutation>
      {mutation => render && render(mutation)}
    </LoanPaymentMutation>
  )
})

export type LoanDetailProps = RouteComponentProps<{ id: string }>

const LoanDetail: React.SFC<LoanDetailProps> = props => {
  const loanId = props.match.params.id
  return (
    <div>
      <Navbar />
      <StyledContainer>
        <Composed loanId={loanId}>
          {({ loan, me, payLoan }) => {
            if (loan.loading || me.loading) {
              return <Loading />
            }

            if (
              loan.error != null ||
              me.error != null ||
              loan.data == null ||
              me.data == null
            ) {
              return <div>Error</div>
            }

            if (loan.data.loan == null) {
              return <div>Not found</div>
            }

            return (
              <div>
                <Headline>{loan.data.loan.description}</Headline>
                <LoanPaymentForm
                  onSubmit={async ({
                    amount,
                    description,
                    payedOn,
                    payers
                  }) => {
                    const result = await payLoan({
                      variables: {
                        loan: loanId,
                        input: {
                          amount: Number(amount),
                          description,
                          payedOn: (payedOn ? payedOn : moment()).format(
                            'YYYY-MM-DD'
                          ),
                          payers: payers.map(debtor => debtor.value)
                        }
                      },
                      refetchQueries: loanQueries(
                        me.data != null &&
                          me.data.user.roles.indexOf(UserRole.ADMIN) !== -1
                      )
                    })

                    if (result == null || result.data == null) {
                      return
                    }

                    history.push(`/loans/${loanId}`)
                  }}
                  loan={loan.data.loan}
                  user={me.data.user}
                />
              </div>
            )
          }}
        </Composed>
      </StyledContainer>
    </div>
  )
}

export default LoanDetail



// WEBPACK FOOTER //
// ./src/screens/LoanPayment.tsx